<div style="display: flex; justify-content: space-between">
  <mat-form-field appearance="fill" style="width: 300px">
    <mat-label>{{ 'Select League' | translate }}</mat-label>
    <mat-select (selectionChange)="onLeagueSelectionChange()" [(ngModel)]="selectedLeagueId">
      <mat-option *ngFor="let league of leagues" [value]="league.id">
        {{ league.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <button (click)="openCreateMatchesModal()" color="primary" mat-raised-button>{{ 'Create matches' | translate }}</button>
</div>

<table [dataSource]="standings" class="mat-elevation-z8 standings-table" mat-table>
  <ng-container matColumnDef="team">
    <th *matHeaderCellDef class="team-column" mat-header-cell>Team</th>
    <td *matCellDef="let element; let i = index" class="team-column" mat-cell>
      <div class="team-cell">
        <span class="team-rank">{{ i + 1 }}.</span>
        <img [src]="element.logoUrl" alt="{{ element.teamName }}" class="team-logo"/>
        <span>{{ element.teamName }}</span>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="matchesPlayed">
    <th *matHeaderCellDef mat-header-cell>MP</th>
    <td *matCellDef="let element" mat-cell>{{ element.matchesPlayed }}</td>
  </ng-container>

  <ng-container matColumnDef="wins">
    <th *matHeaderCellDef mat-header-cell>W</th>
    <td *matCellDef="let element" mat-cell>{{ element.wins }}</td>
  </ng-container>

  <ng-container matColumnDef="draws">
    <th *matHeaderCellDef mat-header-cell>D</th>
    <td *matCellDef="let element" mat-cell>{{ element.draws }}</td>
  </ng-container>

  <ng-container matColumnDef="losses">
    <th *matHeaderCellDef mat-header-cell>L</th>
    <td *matCellDef="let element" mat-cell>{{ element.losses }}</td>
  </ng-container>

  <ng-container matColumnDef="goalsScored">
    <th *matHeaderCellDef mat-header-cell>GF</th>
    <td *matCellDef="let element" mat-cell>{{ element.goalsScored }}</td>
  </ng-container>

  <ng-container matColumnDef="goalsAgainst">
    <th *matHeaderCellDef mat-header-cell>GA</th>
    <td *matCellDef="let element" mat-cell>{{ element.goalsAgainst }}</td>
  </ng-container>

  <ng-container matColumnDef="goalDifference">
    <th *matHeaderCellDef mat-header-cell>GD</th>
    <td *matCellDef="let element" mat-cell>{{ element.goalDifference }}</td>
  </ng-container>

  <ng-container matColumnDef="points">
    <th *matHeaderCellDef mat-header-cell>PTS</th>
    <td *matCellDef="let element" class="points-column" mat-cell>{{ element.points }}</td>
  </ng-container>

  <tr *matHeaderRowDef="displayedStandingsColumns" mat-header-row></tr>
  <tr *matRowDef="let row; columns: displayedStandingsColumns;" mat-row></tr>

</table>

<div *ngFor="let week of weeks" style="margin-top: 2rem">
  <h3>Week {{ week.weekNumber }}</h3>
  <table [dataSource]="weekMatches[week.weekNumber]" class="mat-elevation-z8" mat-table>
    <ng-container matColumnDef="homeTeam">
      <th *matHeaderCellDef mat-header-cell>Skuadra vendase</th>
      <td *matCellDef="let match" mat-cell>{{ match.homeTeamName }}</td>
    </ng-container>
    <ng-container matColumnDef="score">
      <th *matHeaderCellDef mat-header-cell>Rezultati</th>
      <td *matCellDef="let match" mat-cell>{{ match.score }}</td>
    </ng-container>
    <ng-container matColumnDef="awayTeam">
      <th *matHeaderCellDef mat-header-cell>Skuadra mysafire</th>
      <td *matCellDef="let match" mat-cell>{{ match.awayTeamName }}</td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th *matHeaderCellDef mat-header-cell>Data Ndeshjes</th>
      <td *matCellDef="let match" mat-cell>
        {{ match.date ? (match.date | date: 'dd MMM yyyy - HH:mm') : 'Invalid date' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th *matHeaderCellDef mat-header-cell>Statusi</th>
      <td *matCellDef="let match" mat-cell>{{ match.status }}</td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th *matHeaderCellDef mat-header-cell> {{ 'Edito Ndeshjen' | translate }} </th>
      <td *matCellDef="let match" mat-cell>
        <a (click)="openEditMatchModal(match.id)"
           style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
          <i class="fa fa-edit"></i>
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th *matHeaderCellDef mat-header-cell> Fshije </th>
      <td *matCellDef="let match" mat-cell>
        <a (click)="deleteMatch(match.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
          <i class="fa fa-remove"></i>
        </a>
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedMatchColumns" mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedMatchColumns;" mat-row></tr>
  </table>
</div>
